import { render, staticRenderFns } from "./sendPersonEmail.vue?vue&type=template&id=61a5bf56&scoped=true&"
import script from "./sendPersonEmail.vue?vue&type=script&lang=js&"
export * from "./sendPersonEmail.vue?vue&type=script&lang=js&"
import style0 from "./sendPersonEmail.vue?vue&type=style&index=0&id=61a5bf56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5bf56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a5bf56')) {
      api.createRecord('61a5bf56', component.options)
    } else {
      api.reload('61a5bf56', component.options)
    }
    module.hot.accept("./sendPersonEmail.vue?vue&type=template&id=61a5bf56&scoped=true&", function () {
      api.rerender('61a5bf56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/sendPersonEmail.vue"
export default component.exports